/**
 * * Модель запроса на создание задачи
 */
export default class TaskCreateRequest  {
	/**
	 * * Ссылка на проект
	 */
	ProjectId!: number;
	/**
	 * * Номер спринта, если есть
	 */
	SprintId?: number;
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Описание
	 */
	Description!: string;
	/**
	 * * Статус
	 */
	StatusId!: number;
	/**
	 * * Номер типа задачи
	 */
	TypeId?: string;
	/**
	 * * Приоритет
	 */
	PriorityId?: number;
	/**
	 * * Уровень сложности задачи
	 */
	DifficultyId?: string;
	/**
	 * * Номер исполнителя
	 */
	PerformerIds!: Array<number>;
	/**
	 * * Список наблюдателей
	 */
	ObserverIds!: Array<number>;
	/**
	 * * Оценки исполнителей
	 */
	Estimated?: number;
	/**
	 * * Дата дедлайна
	 */
	DateEnd?: Date;
	/**
	 * * Список тегов
	 */
	Tags!: Array<number>;
	/**
	 * * Номер папки (в случае если файлы загрузили до создания задачи)
	 */
	FolderId?: string;
	/**
	 * * Номер родителя
	 */
	ParentId?: number;
	/**
	 * * Номер очереди задач
	 */
	QueueTaskId!: string;
	/**
	 * * Номера подзадач
	 */
	SubtaskIds!: Array<number>;
	/**
	 * * Номер задачи из Weeek api (если был произведен импорт)
	 */
	WeeekTaskId?: number;
	constructor(obj?: Partial<TaskCreateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
